var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.5,
    viewBox: "0 0 20 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_577a1b53ec5ce24f143ebdb283f082d7",
    "data-name": "577a1b53ec5ce24f143ebdb283f082d7",
    d: "M18.949,2.9a.5.5,0,1,0-.65.75A1.848,1.848,0,0,1,19,5.1V16.7a1.878,1.878,0,0,1-1.85,1.85H2.849A1.878,1.878,0,0,1,1,16.7V5.1a1.878,1.878,0,0,1,1.85-1.85h7.5a.5.5,0,0,0,0-1h-7.5A2.817,2.817,0,0,0,0,5.1V16.65a2.881,2.881,0,0,0,2.85,2.85H17.1A2.85,2.85,0,0,0,20,16.7V5.1a2.9,2.9,0,0,0-1.05-2.2ZM14.049,17a.575.575,0,0,0,.45.3.48.48,0,0,0,.45-.3l1.5-3.05a.3.3,0,0,0,.05-.2V2a2,2,0,0,0-4,0V13.75a.241.241,0,0,0,.05.2Zm.45-1.35-.7-1.4h1.4ZM13.5,2a1,1,0,1,1,2,0V6.3h-2Zm0,5.3h2v1h-2Zm0,2.05h2v3.9h-2ZM9.949,8.1h-6.9a.5.5,0,1,0,0,1H10a.462.462,0,0,0,.45-.5.472.472,0,0,0-.5-.5Zm0,2h-6.9a.5.5,0,1,0,0,1H10a.462.462,0,0,0,.45-.5.472.472,0,0,0-.5-.5Zm0,2h-6.9a.5.5,0,1,0,0,1H10a.462.462,0,0,0,.45-.5.472.472,0,0,0-.5-.5Z",
    transform: "translate(0.001)",
    fill: "#74613c",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.14c28c28f66f12c119ba8cf79ebea2bb.svg";
export { ForwardRef as ReactComponent };